import { createIsomorphicFn, createServerFn } from '@tanstack/react-start';
import { useSession } from '@tanstack/react-start/server';

import { getSessionPassword } from '@/auth/session';

const useStableID = () => {
  return useSession<{ stableID?: string }>({
    name: 'app-stable-id',
    password: getSessionPassword(),
    cookie: {
      secure: process.env.NODE_ENV === 'production',
      httpOnly: true,
      sameSite: 'lax',
      maxAge: 60 * 60 * 24 * 30,
    },
  });
};

const fetchStableId = createServerFn({
  method: 'POST',
}).handler(async () => {
  const session = await useStableID();
  if (session.data?.stableID) {
    return session.data.stableID;
  }
  const newStableID = crypto.randomUUID();
  await session.update({ stableID: newStableID });
  return newStableID;
});

let cachedStableId: Promise<string> | undefined;

export const getStableId = createIsomorphicFn()
  .server(() => fetchStableId())
  .client(() => {
    cachedStableId ??= fetchStableId();
    return cachedStableId;
  });
